<template>
  <div class="page">
    <van-icon class="icon" name="arrow-left" color="#181616" size="20" @click="back" />
    <img class="activity_bg" src="../../../../assets/house/property/activity_bg.png" alt="">
    <div class="page_btn">
      <van-row type="flex" justify="center" gutter="20">
        <van-col span="22">
          <div @click="apply = !apply" v-if="apply" class="btn">报名</div>
          <div @click="apply = !apply" v-else class="btn_cancel">取消报名</div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        apply: true,
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="less" scoped>
  .page {
    position: relative;
  }

  .icon {
    position: absolute;
    top: 44px;
    left: 16px;
  }

  .activity_bg {
    width: 100%;
    padding-bottom: 44px;
  }

  .page_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 98px;
    padding-top: 8px;
    background-color: #FFFFFF;
  }

  .btn {
    height: 48px;
    background: #26C165;
    border-radius: 6px;
    text-align: center;
    line-height: 48px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
  }

  .btn_cancel {
    height: 48px;
    background: #FFF1E9;
    border-radius: 6px;
    text-align: center;
    line-height: 48px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #FF6030;
  }
</style>